import React from 'react';
import PropTypes from 'prop-types';
import SvgImg from '../SvgImg';

function idify(title) {
  return (title || '').replace(/ /gi, '-');
}
/* eslint-disable indent */

const SvgIcon = (
  {
    viewbox,
    title,
    fill,
    stroke,
    strokeWidth,
    children,
    ...others
  },
) => (
  <SvgImg
    viewbox={viewbox}
    title={title}
    fill={fill}
    stroke={stroke}
    strokeWidth={strokeWidth}
    {...others}
  >
    <g
      id="Symbols"
      stroke={stroke}
      strokeWidth={strokeWidth}
      fill="none"
      fillRule="evenodd"
    >
      <g id={idify(title)} fill={fill}>
        {children}
      </g>
    </g>
  </SvgImg>
  );

const elementOrArrayOfElementPropType = PropTypes.oneOfType([
  PropTypes.arrayOf(PropTypes.element),
  PropTypes.element,
]);

SvgIcon.propTypes = {
  viewbox: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(elementOrArrayOfElementPropType),
    elementOrArrayOfElementPropType,
  ]),
};
SvgIcon.defaultProps = {
  fill: '#828282',
  stroke: 'none',
  strokeWidth: '1',
  children: [],
};
export default SvgIcon;
